import React from 'react';
import { number } from 'prop-types';
import {
 getFieldRenderFunction, renderUnifiedPcsName, renderNamesString, renderNullFloatValues,
} from '../pages/index/Shared';
import { dateRenderer } from '../services/formatSvc';
import { arrayToLookup } from './table';
import FilterMultiSelect from '../components/table/FilterMultiSelect';

export const getTitleByParams = async ({
  stratId, policyId, portfolioId, projId,
}, api) => {
  const base = 'Унифицированные показатели';

  if (projId) return `${base} проекта`;
  if (portfolioId) return `${base} проектов портфеля`;
  // if (stratId || policyId) {
  //   const stratProj = await api.get(`/mng/strategies/${stratId}`);
  //   return `${base} ${stratProj.num} "${stratProj.name}"`;
  // }

  return `${base} проектов`;
};

export const renderPrettySum = (sum) => {
  const renderSum = (number) => (
    <span>
      {new Intl.NumberFormat('ru-RU').format(number)}
    </span>
  );

  switch (typeof sum) {
    case 'number':
      return renderSum(sum);
    case 'string':
      return renderSum(Number(sum.replace(/\s/g, ''))); // удаление пробелов из строки и преобразование в число
    default: // null || undefined
      return '';
  }
};

export const getDetailUnifiedCols = (originalData, entity, callback) => {
  const teamMembersCols = [
    {
      title: '№',
      field: 'num',
      editable: 'never',
      width: '80px',
      filterCellStyle: { minWidth: '80px' },
      filtering: true,
      sticky: true,
    },
    {
      title: 'Стратегический проект',
      field: 'strategyName',
      editable: 'never',
      filterCellStyle: { minWidth: '270px' },
      sticky: true,
      width: '270px',
      lookup: arrayToLookup('strategyName', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: '№ и название проекта',
      field: 'projName',
      editable: 'never',
      width: '300px',
      filterCellStyle: { minWidth: '300px' },
      filtering: true,
      sticky: true,
    },
    {
      title: 'Руководитель проекта',
      field: 'projHead',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'ФИО участника',
      field: 'fullName',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'Роль',
      field: 'role',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'Должность',
      field: 'post',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'Вид трудоустройства',
      field: 'employmentType',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'Подразделение',
      field: 'division',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      filtering: true,
    },
    {
      title: 'Категория',
      field: 'category',
      width: 120,
      hidden: true,
      hiddenByColumnsButton: true,
      cellStyle: { minWidth: '120px' },
    },
    {
      title: 'Доля занимаемой ставки',
      field: 'rate',
      width: 120,
      hidden: true,
      hiddenByColumnsButton: true,
      cellStyle: { minWidth: '120px' },
    },
    {
      title: 'Дата включения в проект',
      field: 'inclusionDate',
      editable: 'never',
      width: '140px',
      filterCellStyle: { minWidth: '140px' },
      filtering: true,
    },
    {
      title: 'Дата искл. из проекта',
      field: 'exclusionDate',
      editable: 'never',
      width: '140px',
      filterCellStyle: { minWidth: '140px' },
      filtering: true,
    },
    {
      title: '% участия в проекте',
      field: 'share',
      render: (rowData) => (
        <span>
          {rowData?.share * 100}
          %
        </span>
      ),
      width: '135px',
      hidden: true,
      hiddenByColumnsButton: true,
      cellStyle: { minWidth: '135px' },
    },
    {
      title: 'Сотрудник до 39 лет',
      field: 'isYoung',
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
      lookup: arrayToLookup('isYoung', originalData),
      filterComponent: FilterMultiSelect,
    },
  ];

  const contractsCols = [
    {
      title: 'Стратегический проект',
      field: 'strategyName',
      editable: 'never',
      filterCellStyle: { minWidth: '190px' },
      sticky: true,
      width: '190px',
      lookup: arrayToLookup('strategyName', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: '№ и название проекта',
      field: 'projName',
      editable: 'never',
      width: '230px',
      filterCellStyle: { minWidth: '230px' },
      sticky: true,
      lookup: arrayToLookup('projName', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Руководитель проекта',
      field: 'projHead',
      editable: 'never',
      width: '150px',
      filterCellStyle: { minWidth: '150px' },
      lookup: arrayToLookup('projHead', originalData),
      filterComponent: FilterMultiSelect,
      sticky: true,
    },
    {
      title: 'Наименование темы',
      field: 'name',
      editable: 'never',
      filterCellStyle: { minWidth: '217px' },
      lookup: arrayToLookup('name', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: '№ темы',
      field: 'code',
      editable: 'never',
      width: '150px',
      filterCellStyle: { minWidth: '150px' },
      lookup: arrayToLookup('code', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Руководитель темы',
      field: 'topicHeads',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      render: (rowData) => renderNamesString(rowData.topicHeads),
      lookup: arrayToLookup('topicHeads', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Институт (где работает руководитель темы)',
      field: 'headsInstitute',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      render: (rowData) => renderNamesString(rowData.headsInstitute),
      lookup: arrayToLookup('headsInstitute', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Сумма лицевого счета/договора (всего), руб.',
      field: 'contractSum',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
    },
    {
      title: 'Сумма договора, руб. (с учетом % уч.проекта)',
      field: 'contractSumWithShare',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
    },
    {
      title: '% участия проекта в реализации договора',
      field: 'shareNew',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
    },
    {
      title: '№ договора',
      field: 'num',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      lookup: arrayToLookup('num', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Дата начала договора',
      field: 'regDate',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      render: (rowData) => dateRenderer(rowData.regDate),
      lookup: arrayToLookup('regDate', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Дата окончания договора',
      field: 'endDate',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      render: (rowData) => dateRenderer(rowData.endDate),
      lookup: arrayToLookup('endDate', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Основной исполнитель договора',
      field: 'isPrimaryParticipantTitle',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      lookup: arrayToLookup('isPrimaryPracticantTitle', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Год поступления средств',
      field: 'year',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      lookup: arrayToLookup('year', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Тип',
      field: 'actualType',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      lookup: arrayToLookup('type', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Контрагент',
      field: 'contragentName',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      lookup: arrayToLookup('contragentName', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'ИНН контрагента',
      field: 'contragentInn',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
    },
    {
      title: 'Сумма поступлений по договору, руб.',
      field: 'paymentOrderSum',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
    },
    {
      title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
      field: 'paymentOrderSumWithShare',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
    },
    {
      title: 'Реквизиты платежных поручений',
      field: 'paymentOrdersField',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
    },
    {
      title: 'Сумма актов, руб.',
      field: 'paymentActSum',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
    },
    {
      title: 'Сумма актов, руб. (с учетом % уч.проекта)',
      field: 'paymentActSumWithShare',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
    },
    {
      title: 'Реквизиты актов',
      field: 'paymentActsField',
      editable: 'never',
      filterCellStyle: { minWidth: '227px' },
      filtering: true,
    },
  ];

  let baseUnifiedCols;

  switch (entity) {
    case 'teamMembers':
    case 'teamMemberCounts':
      baseUnifiedCols = teamMembersCols;
      break;
    case 'contracts':
      baseUnifiedCols = contractsCols;
      break;
    default:
      baseUnifiedCols = [];
      break;
  }

  if (callback) {
    return callback(baseUnifiedCols);
  }

  return baseUnifiedCols;
};

export const getCols = (originalData, params, callback, navProject) => {
  // основные колонки в таблице на уровне программы
  const programLevelCols = [
    {
      title: 'Показатель',
      field: 'name',
      editable: 'never',
      render: (rowData) => renderUnifiedPcsName(rowData, params, navProject),
      filterCellStyle: { minWidth: '300px' },
      width: '300px',
      lookup: arrayToLookup('name', originalData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Единица',
      field: 'unit',
      render: (rowData) => (rowData.unit === 'рублей' ? 'тыс. руб.' : rowData.unit),
      editable: 'never',
      width: '100px',
      filterCellStyle: { minWidth: '100px' },
    },
  ];

  // основные колонки в таблице на уровне СП
  const stratLevelCols = [
    {
      title: '№',
      editable: 'never',
      field: 'num',
      filterCellStyle: { minWidth: '80px' },
      width: '80px',
    },
    {
      title: 'Наименование проекта',
      editable: 'never',
      field: 'name',
      filterCellStyle: { minWidth: '300px' },
      filterComponent: FilterMultiSelect,
      lookup: arrayToLookup('name', originalData),
      width: '300px',
    },
    {
      title: 'Руководитель проекта',
      editable: 'never',
      field: 'projHead',
      filterCellStyle: { minWidth: '200px' },
      width: '200px',
    },
  ];

  let baseUnifiedCols;

  if (params.stratLevel) {
    baseUnifiedCols = stratLevelCols;
  } else {
    baseUnifiedCols = programLevelCols;
  }

  if (callback) {
    return callback(baseUnifiedCols);
  }

  return baseUnifiedCols;
};

export const createFirstCols = (originalData, navProject, type, ids) => {
  const {
    stratId, projId, policyId, portfolioId,
  } = { ...ids };
  if (['strat', 'proj'].includes(type)) {
    {
      return getCols(originalData, {
        stratId, projId, policyId, portfolioId,
      }, null, navProject).renameCol('name', 'Показатель');
    }
  }
};
